import React from "react";
import { compose } from "containers/HOC";
import { withFarmsPublishedToMyOrg, withAggregatedReporting } from "containers/Reporting/ReportingHOC";
import { usePortalModal } from "common/effects";
import ActionLink from "components/ActionLink";
import Page from "components/Page";
import PageBody from "components/PageBody";
import Reporting from "containers/Reporting/Reporting";
import FarmTagsModal from "containers/FarmTags/FarmTagsModal";

const Publications = ({ online, farms, reloadFarmTags, ...rest }) => {
    const { openModal, getModal } = usePortalModal();

    const tagFarms = async () => {
        openModal("FarmTagsModal", { farms }, reloadFarmTags);
    };
    const farmTagsModal = getModal("FarmTagsModal", FarmTagsModal);

    return (
        <>
            <Page>
                <section className="PageHead">
                    <div className="Container">
                        <div className="FarmTitle">
                            <div className="FarmTitle-heading FarmTitle-heading--lg">
                                <span id="page-head-title" className="FarmTitle-name">
                                    Publication Reporting
                                </span>
                            </div>
                        </div>
                        {online && (
                            <div className="PageHead-actions u-print-none">
                                <ActionLink id="tag-farms-link" className="IconLink--tag u-link" onClick={tagFarms}>
                                    Tag farms
                                </ActionLink>
                            </div>
                        )}
                    </div>
                </section>
                <PageBody>
                    <Reporting farms={farms} {...rest} />
                </PageBody>
            </Page>
            {farmTagsModal}
        </>
    );
};

export default compose(withFarmsPublishedToMyOrg, withAggregatedReporting)(Publications);
